import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Loading from "Components/Loading";
import { apiSendMessageToRD } from "Root/api/apiCheckout";
import toastService from "Root/profile/toastService/index";
import { useEffect, useState } from "react";
import GainfulButton from "../../GainfulButton";
import LoadingMessage from "./LoadingMessage";
import styles from "./styles.module.css";
// export interface PropsNew {
//   conversationArray: {id: string, text: string; fromRd: boolean; answerIds: string[]; showInput?: boolean }[];
//   rdImg: string;
//   initials?: string;
// }
const DietitianMessagesInteractive = ({ conversationArray, rdImg, initials }) => {
    const [answered, setAnswered] = useState([0]);
    const [loadingIndex, setLoadingIndex] = useState(null);
    const [inputValue, setInputValue] = useState("");
    const [isSending, setIsSending] = useState(false);
    const handleClick = (index) => {
        setLoadingIndex(index + 1);
        setAnswered([...answered, index, index + 1]);
        const timeout = setTimeout(() => {
            setLoadingIndex(null);
            clearTimeout(timeout);
        }, 3000);
    };
    const sendMessage = async () => {
        try {
            setIsSending(true);
            await apiSendMessageToRD({ msg: inputValue });
            setInputValue("");
            setIsSending(false);
            toastService.successMessage("Your RD has been notified of your question, and will be in contact soon!");
        }
        catch (err) {
            setIsSending(false);
            toastService.errorMessage("Sorry, something went wrong.");
        }
    };
    useEffect(() => {
        try {
            const items = JSON.parse(localStorage.getItem("dietitianMessages") || "[0]");
            setAnswered(items);
        }
        catch (e) {
            console.log(e);
            setAnswered([0]);
        }
    }, []);
    useEffect(() => {
        localStorage.setItem("dietitianMessages", JSON.stringify(answered));
    }, [answered]);
    return (_jsx("div", { className: styles.msg_container, children: conversationArray.map((message, index) => (_jsxs("div", { className: `${styles.message} ${message.fromRD ? styles.fromRD : styles.fromCustomer} ${index === 0 || answered.includes(index) ? styles.show : ""}`, children: [message.fromRD && _jsx("img", { src: rdImg, alt: "Personal Registered Dietitian", className: styles.image }), message.fromRD || answered.includes(index) ? (_jsx("p", { className: `${styles.note} ${loadingIndex === index ? styles.loading : ""}`, children: loadingIndex === index ? _jsx(LoadingMessage, {}) : message.text })) : (_jsx("button", { className: styles.note, onClick: () => {
                        handleClick(index);
                    }, type: "button", children: message.text })), !message.fromRD && _jsx("div", { className: styles.initials, children: initials }), message.showInput &&
                    (isSending ? (_jsx(Loading, {})) : (_jsxs("div", { className: styles.input_wrapper, children: [_jsx("textarea", { className: styles.input, placeholder: "Ask your question here...", value: inputValue, onChange: (e) => {
                                    setInputValue(e.target.value);
                                } }), _jsx(GainfulButton, { text: "Send to my R.D.", onClick: sendMessage, disabled: !inputValue.length })] })))] }, message.text))) }));
};
export default DietitianMessagesInteractive;
